export const enum BankTransferRecipientType {
  Business = 'business',
  Individual = 'individual'
}

export type BankTransferRecipient = {
  id: number;
  firstName: string;
  lastName: string;
  nickname: string;
  type: BankTransferRecipientType;
  iban: string;
  bic: string;
  bankName: string;
  amount: number;
};

export type CheckIBANResponse = {
  iban: string;
  bic: string;
  bankName: string;
  isIBANValid: boolean;
  isCountryValid: boolean;
};
